import PropTypes from 'prop-types';
import { joinClassNames as c } from 'Shared/util/styles';
import InlineSvg from 'Shared/components/inline-svg';
import styles from './return-title.css';


const ReturnTitle = ({
  title,
  onClick,
  display,
  className,
}) => (display && (
  <div
    className={c(styles.container, className)}
    onClick={onClick}
    onKeyDown={() => null}
  >
    <InlineSvg
      className={styles.svgContainer}
      src="/caret-left.svg"
    />
    <h3>{title}</h3>
  </div>
));

ReturnTitle.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  display: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default ReturnTitle;
